import { XYChartModel, BarSeriesModel, LineSeriesModel, Coordinate, AttributeCoordinateModel, BandScaleModel } from '@leverege/ui-attributes-graphs';
const UNGRAPHABLE_CORDINATE_TYPES = ['string', 'boolean', 'geoPoint', 'geoJson', 'shape', 'ip', 'relationship', 'parentRelationship', 'enum', 'resourceEnum'];
function create(blueprint) {
  return {
    id: `${blueprint.alias}.history.XYChartModelConfigurer`,
    matches: {
      objectType: blueprint.historyType
    },
    configure: (xyChartModel, objectType, context) => {
      let model = XYChartModel.setSeriesType(xyChartModel, LineSeriesModel.create());
      const timeCoordinate = Coordinate.getCoordinate(`${objectType}.time`, objectType);
      if (timeCoordinate) {
        model = XYChartModel.setXCoordinate(model, timeCoordinate.create());
      }
      const numberCoordinate = Coordinate.getCoordinatesFor(objectType).find(coord => !UNGRAPHABLE_CORDINATE_TYPES.includes(coord.valueType));
      if (numberCoordinate) {
        model = XYChartModel.setYCoordinate(model, numberCoordinate.create());
      }
      return model;
    }
  };
}
const AggregationResultConfigurer = {
  id: 'aggResult.XYChartModelConfigurer',
  matches: {
    objectType: 'aggResult'
  },
  configure: (xyChartModel, objectType, context) => {
    let model = XYChartModel.setSeriesType(xyChartModel, BarSeriesModel.create());
    const keyCoordinate = Coordinate.getCoordinate(`${objectType}.key`, objectType);
    if (keyCoordinate) {
      let coordinateModel = keyCoordinate.create();
      coordinateModel = AttributeCoordinateModel.setScale(coordinateModel, BandScaleModel.create());
      model = XYChartModel.setXCoordinate(model, coordinateModel);
    }
    const valueCoordinate = Coordinate.getCoordinate(`${objectType}.value`, objectType);
    if (valueCoordinate) {
      model = XYChartModel.setYCoordinate(model, valueCoordinate.create());
    }
    return model;
  }
};
const BlueprintAnalyzer = {
  sort: 100,
  processBlueprints(molten, blueprints) {
    blueprints.forEach(b => {
      molten.addPlugin('XYChartModelConfigurer', create(b));
    });
  }
};
export default {
  create,
  BlueprintAnalyzer,
  AggregationResultConfigurer
};